import { BACKEND_URL } from "@/lib/api";

export function itemRows(catalog, item) {
  const style = (catalog?.styles || []).find((s) => s.id === item.style_id);
  if (!style) return [];
  const rows = [];
  for (const grp of style.groups) {
    const val = item.selections?.[grp.id];
    if (val == null || val === "" || (Array.isArray(val) && !val.length)) continue;
    if (grp.type === "image") { rows.push({ label: grp.label, value: "Photo attached", image: `${BACKEND_URL}${val}` }); continue; }
    if (grp.type === "images") { (Array.isArray(val) ? val : []).forEach((u, i) => rows.push({ label: `${grp.label} ${i + 1}`, value: "Photo attached", image: `${BACKEND_URL}${u}` })); continue; }
    if (grp.multi) {
      const labels = (Array.isArray(val) ? val : []).map((v) => grp.options.find((x) => x.value === v)?.label || v);
      rows.push({ label: grp.label, value: labels.join(", ") });
    } else {
      const opts = grp.options_map ? Object.values(grp.options_map).flat() : grp.options;
      rows.push({ label: grp.label, value: opts.find((x) => x.value === val)?.label || val });
    }
  }
  return rows;
}

export const isNewOrder = (o) => o.status === "placed" && o.payment_status !== "pending";
